import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { selectSceneComments } from 'redux/db/reducers';
import { addCommentIntroShownForScene, setActiveCommentId } from 'redux/mode/actions';
import { selectTransform } from 'redux/mode/reducers';
import { navigateToComment } from 'redux/mode/util';
import { RootReducer } from 'redux/reducers';
import * as S from './styles';

const CommentMarkers = () => {
	const dispatch = useDispatch();

	const { comments, transform, activeCommentId, hoveredCommentId, commentIntroShownForScenes } =
		useSelector(
			(r: RootReducer) => ({
				comments: selectSceneComments(r.db),
				transform: selectTransform(r.mode),
				activeCommentId: r.mode.activeCommentId,
				hoveredCommentId: r.mode.hoveredCommentId,
				commentIntroShownForScenes: r.mode.commentIntroShownForScenes,
			}),
			shallowEqual
		);

	// Clear active comment when it gets deleted (no longer in the list)
	useEffect(() => {
		if (activeCommentId && !comments.find((c) => c.id === activeCommentId)) {
			dispatch(setActiveCommentId(null));
		}
	}, [comments, activeCommentId, dispatch]);

	// Auto-navigate to first comment when loading a scene with comments for the first time in this tab
	useEffect(() => {
		if (comments.length === 0) return;
		const sceneId = comments[0].sceneId;
		if (commentIntroShownForScenes.includes(sceneId)) return;
		dispatch(addCommentIntroShownForScene(sceneId));
		navigateToComment(comments[0]);
	}, [comments, commentIntroShownForScenes, dispatch]);

	//----------------------------------------------------------------------
	// RENDERING
	//----------------------------------------------------------------------

	if (comments.length === 0) return null;

	const counterScale = 1 / transform.scale;

	return (
		<>
			{comments.map((comment, index) => {
				const isHovered = comment.id === hoveredCommentId;
				const isActive = comment.id === activeCommentId;
				return (
					<S.Marker
						key={comment.id}
						x={comment.x}
						y={comment.y}
						$counterScale={counterScale}
						$hovered={isHovered}
						$active={isActive}
					>
						<S.MarkerNote $hovered={isHovered} $active={isActive}>
							<S.MarkerLabel>{index + 1}</S.MarkerLabel>
						</S.MarkerNote>
					</S.Marker>
				);
			})}
		</>
	);
};

export default CommentMarkers;
